// Package imports
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import TextField from "@mui/material/TextField";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import AudioButton from "../../../../Components/Media/AudioButton";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PauseIcon from "@mui/icons-material/Pause";
import StatusIndicator from "../../../../Components/Card/AssetUI/StatusIndicator";

// Custom imports
import { currentAssetSliceActions } from "../../../../Store/Slices/CurrentAssetSlice";
import {
  unicodeToString,
  concatAllArraysWithDuplicate,
  shuffle,
} from "../../../../Js/Common";
import OptionMedia from "../../../../Components/Card/AssetUI/OptionMedia";

// Global variables
var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const refData = [];

// Component
function FIBDND(props) {
  // Hooks
  const classes = useStyles();
  const dispatch = useDispatch();

  // State
  const [userAnswer, setUserAnswer] = useState([]);
  const [logObj, setLogObj] = useState(initLogObj);
  const [fibContent, setFibContent] = useState([]);
  const [dragOptions, setDragOptions] = useState([]);
  const [received, setReceived] = useState([]);
  const [currentOptionIndex, setCurrentOptionIndex] = useState(0);
  const [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      let actualAnswers = [];
      let userAnswers = [];
      let innerAnsArr, userAnsArray, innerAnsArr1, userAnsArray1;
      let content = props.content.epage.options.content.map((val, index) => {
        let obj = { ...val };
        let tempstr = obj.text;
        let str;

        if (obj.answer.length === 0) {
          tempstr = unicodeToString(tempstr);
          innerAnsArr = [[]];
        } else {
          innerAnsArr = [];
          obj.answer.forEach((ans, index1) => {
            innerAnsArr1 = [];
            userAnsArray = [];
            if (ans.length > 0) {
              ans.forEach((innerAns, index2) => {
                innerAnsArr1.push(unicodeToString(innerAns.value));
                console.log("index", index);
                console.log("index1", index1);
                console.log("index2", index2);
                if (innerAns.status == true) {
                  let replace_str =
                    '<span class="btn btn--small blue" id="btn_' +
                    index +
                    "_" +
                    index1 +
                    '" contenteditable="false">' +
                    unicodeToString(unicodeToString(innerAns.value)) +
                    "</span>";
                  if (!str) {
                  }
                  str = unicodeToString(tempstr);
                  if (str) {
                    str = str.replace(/^<div[^>]*>|<\/div>$/g, "");
                    str = str.replace(/&nbsp;/g, " ");
                    str = str.replace(
                      replace_str,
                      "***|_btn_" + index + "_" + index1 + " "
                    );
                    str = str.replace("<br>", "");
                    str = str.replace(/\n/g, " ");
                    tempstr = str;
                  }
                }
              });
              innerAnsArr.push(innerAnsArr1);
            }
          });
        }
        console.log("!!!!tempstr", obj.answer.length);
        actualAnswers.push(innerAnsArr);
        userAnswers.push(new Array(obj.answer.length).fill([]));
        return tempstr;
      });
      let dragOpt = concatAllArraysWithDuplicate(
        concatAllArraysWithDuplicate(actualAnswers)
      );
      setDragOptions(shuffle(dragOpt));
      console.log(
        "actualAnswers",
        concatAllArraysWithDuplicate(
          concatAllArraysWithDuplicate(actualAnswers)
        )
      );
      setFibContent(content);
      setUserAnswer(userAnswers);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(userAnswers));
      console.log("userAnsArray", userAnswers);
      let obj = {
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      };
      setLogObj(obj);
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    setCurrentOptionIndex(0);
  }, [logObj]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    let userAns = props.content.epage.options.content.map((val) => {
      return new Array(val.answer.length).fill([]);
    });
    setUserAnswer(userAns);
    dispatch(currentAssetSliceActions.setCurrentAttemptData(userAns));
    if (logObj?.actualAnswer?.length > 0) {
      let dragOpt = concatAllArraysWithDuplicate(
        concatAllArraysWithDuplicate(logObj.actualAnswer)
      );
      setDragOptions(shuffle(dragOpt));
    }
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      let showAllAnswer = assetLogObj.actualAnswer.map((val) => {
        return val.map((val1) => {
          return val1.join(" | ");
        });
      });
      setUserAnswer(showAllAnswer);
      setDragOptions([]);
      setCurrentOptionIndex(0);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const updateUserAnswer = (valIndex, text) => {
    console.log("currentOptionIndex", currentOptionIndex);
    console.log("valIndex", valIndex);
    console.log("text", text);
    if (!showAnswer && !attempted) {
      let addToDrag = "";
      let newArray = [...userAnswer];
      let innerArray = newArray[currentOptionIndex].map((item, i) => {
        if (valIndex === i) {
          if (item.length > 0) {
            addToDrag = item;
          }
          return text;
        } else {
          return item;
        }
      });
      newArray[currentOptionIndex] = [...innerArray];
      setUserAnswer(newArray);
      removeFromActualContent(text, addToDrag);
      dispatch(currentAssetSliceActions.setCurrentAttemptData([...newArray]));
    }
  };

  const removeFromActualContent = (text, addToDrag) => {
    console.log("text", text);
    let position = dragOptions.indexOf(text);
    console.log("dragOptions", dragOptions);
    if (position != -1) {
      let newArray = [...dragOptions];
      if (addToDrag.length > 0) {
        newArray.splice(position, 1, addToDrag);
      } else {
        newArray.splice(position, 1);
      }
      setDragOptions(newArray);
    }
  };

  const getBlankIndex = (que) => {
    let count = 0;
    que = que.replace(/<[^>]*>?/gm, "");
    return que.split(" ").map((val) => {
      if (val.includes("*")) {
        return {
          word: val,
          ind: count++,
          lengthinput: 10,
          buttonid: val.split("|_")[1],
        };
      } else {
        return {
          word: val,
          lengthinput: 10,
        };
      }
    });
  };

  const grid = 8;

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `4px ${grid}px 4px 4px`,

    // change background colour if dragging
    background: "#fff",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getItemStyle1 = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    margin: `4px ${grid}px 4px 4px`,

    // change background colour if dragging
    background: "#fff",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    display: "flex",
    padding: grid,
    overflow: "auto",
    minHeight: "50px",
  });

  const getListStyle1 = (isDraggingOver) => ({
    display: "inline-flex",
    padding: grid,
    overflow: "auto",
    width: "auto",
    borderBottom: "1px solid",
    minWidth: "100px",
  });

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  /**
   * Moves an item from one list to another list.
   */
  const move = (source, destination, droppableSource, droppableDestination) => {
    var sourceClone, destClone;

    console.log(
      "&&&&&*******",
      source,
      destination,
      droppableSource,
      droppableDestination
    );
    let indx = droppableSource.index;
    if (droppableSource.droppableId == "droppable") {
      sourceClone = Array.from(source);
      destClone = Array.from(destination);
    } else {
      sourceClone = Array.from(destination);
      destClone = Array.from(source);
      indx = droppableSource.droppableId.split("_")[1];
    }

    console.log("&&&&&*******1111", sourceClone, destClone);
    const [removed] = sourceClone.splice(+indx, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    console.log("result", result);

    return result;
  };

  const onDragEnd = (result) => {
    console.log("res", result);
    if (!showAnswer && !attempted) {
      const { source, destination } = result;

      // dropped outside the list
      if (!destination) {
        return;
      }

      if (
        source.droppableId !== "droppable" &&
        destination.droppableId !== "droppable"
      ) {
        return;
      }

      let dropId = result.destination.droppableId.split("_");
      if (source.droppableId === destination.droppableId) {
        if (source.droppableId === "droppable") {
          console.log("111111111111111111111111111111111");
          const items = reorder(dragOptions, source.index, destination.index);
          setDragOptions(items);
        } else {
          console.log("22222222222222222222222222222222222");
          const items2 = reorder(
            userAnswer[dropId[0]],
            source.index,
            destination.index
          );
          let newArray = [...userAnswer];
          newArray[dropId[0]] = items2;
          setUserAnswer(newArray);
        }
      } else {
        let result1, newDrop;
        let newArray = [...userAnswer];
        if (source.droppableId === "droppable") {
          console.log("3333333333333333333333333333333");
          if (userAnswer[dropId[0]][dropId[1]].length > 0) {
            return;
          }
          result1 = move(
            dragOptions,
            userAnswer[dropId[0]][dropId[1]],
            source,
            destination
          );
          console.log("result1222", result1);
          newDrop = result1[`${dropId[0]}_${dropId[1]}_drop`];
          let innerArr = [...newArray[dropId[0]]];
          innerArr[dropId[1]] = newDrop;
          newArray[dropId[0]] = innerArr;
          console.log("newArray", newArray);
        } else {
          console.log("44444444444444444444444444444444");
          console.log("USerans", userAnswer);
          let dragId = result.source.droppableId.split("_");
          console.log("dragId", dragId);
          if (userAnswer[dragId[0]][dragId[1]].length == 0) {
            return;
          }
          result1 = move(
            dragOptions,
            userAnswer[dragId[0]],
            source,
            destination
          );
          let innerArr = [...newArray[dragId[0]]];
          innerArr[dragId[1]] = new Array();
          newArray[dragId[0]] = innerArr;
        }

        setDragOptions(concatAllArraysWithDuplicate(result1.droppable));
        setUserAnswer(newArray);
        dispatch(currentAssetSliceActions.setCurrentAttemptData([...newArray]));
        //setReceived(result.droppable2);
      }
    }
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  // const getListStyle1 = (isDraggingOver) => ({
  //   display: "flex",
  //   padding: grid,
  //   overflow: "auto",
  //   borderBottom: "2px solid #D9D9D9",
  //   width: "auto",
  //   marginTop: 30,
  // });

  // JSX template

  return (
    <div>
      {props.content && (
        <>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="horizontal">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                  {...provided.droppableProps}
                  className={classes.scrollBarHeight}
                >
                  {dragOptions &&
                    dragOptions.length > 0 &&
                    dragOptions.map((item, index) => (
                      <Draggable
                        key={`${index}_drag12`}
                        draggableId={`${index}_drag12`}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <Box
                            sx={{
                              lineHeight: 1,
                              border: 1,
                              borderColor: "#D9D9D9",
                              color: "primary.main",
                              fontWeight: "700",
                              fontSize: "0.9rem",
                              borderRadius: 10,
                              boxShadow: 0,
                              minWidth: "5rem",
                              maxWidth: "10rem",
                              cursor: "pointer",
                              display: "inline",
                              padding: 1,
                              marginX: 1,
                              textAlign: "center",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                                minWidth: "8rem",
                                maxWidth: "16rem",
                              },
                            }}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            {item}
                          </Box>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            <div  >
              {props.content.epage.options.content.map((item, index1) => {
                return (
                  <Box sx={{ mt: 4 }} key={`${index1}_options`}>
                    <List
                      dense
                      sx={{
                        borderBottom: 2,
                        borderBottomColor: "#EFEFEF",
                        padding: 0,
                        paddingBottom: 1,
                        my: 2,
                      }}
                    >
                      <ListItem
                        sx={{ pa: 0, paddingTop: "0px", paddingBottom: "0px" }}
                      >
                        {item && item.media && (
                          <OptionMedia
                            media={item.media}
                            isPlaying={currentIndexPlay[index1]}
                            setPlayMode={(status, end) => {
                              setPlayMode(status, index1, end);
                            }}
                          ></OptionMedia>
                        )}
                        <ListItemText
                          classes={{ primary: classes.ListItemText }}
                          sx={{ color: "primary.main", pl: 1 }}
                        >
                          {fibContent &&
                            fibContent.length > 0 &&
                            fibContent[index1] &&
                            getBlankIndex(fibContent[index1]).map(
                              (val, index2) => {
                                return (
                                  <>
                                    {!val.word.includes("*") && (
                                      <Typography
                                        color="primary.main"
                                        sx={{
                                          lineHeight: 2.3,
                                          fontWeight: "500",
                                          fontSize: "0.9rem",
                                          display: "inline-block",
                                          mx: 0.5,
                                          "@media (min-width: 1636px)": {
                                            fontSize: "1.4rem",
                                          },
                                        }}
                                        key={`${index2}_text`}
                                      >
                                        {" "}
                                        {val.word}
                                      </Typography>
                                    )}
                                    {val.word.includes("*") && (
                                      <Droppable
                                        droppableId={`${index1}_${val.ind}_drop`}
                                        direction="horizontal"
                                        index={0}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            style={getListStyle1(
                                              snapshot.isDraggingOver
                                            )}
                                            {...provided.droppableProps}
                                          >
                                            {userAnswer[index1] &&
                                              userAnswer[index1].length > 0 && (
                                                <>
                                                  <Draggable
                                                    key={`${index1}_${index2}_drag1`}
                                                    draggableId={`${index1}_${index2}_drag1`}
                                                    index={0}
                                                  >
                                                    {(provided, snapshot) => (
                                                      <Box
                                                        sx={{
                                                          lineHeight: 1,
                                                          color: "primary.main",
                                                          fontWeight: "700",
                                                          fontSize: "0.9rem",
                                                          borderRadius: 10,
                                                          boxShadow: 0,
                                                          minWidth: "5rem",
                                                          maxWidth: "10rem",
                                                          cursor: "pointer",
                                                          display: "inline",
                                                          padding: 1,
                                                          marginX: 1,
                                                          textAlign: "center",
                                                          "@media (min-width: 1636px)":
                                                            {
                                                              fontSize:
                                                                "1.4rem",
                                                              minWidth: "8rem",
                                                              maxWidth: "16rem",
                                                            },
                                                        }}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle1(
                                                          snapshot.isDragging,
                                                          provided
                                                            .draggableProps
                                                            .style
                                                        )}
                                                      >
                                                        {
                                                          userAnswer[index1][
                                                            val.ind
                                                          ]
                                                        }
                                                      </Box>
                                                    )}
                                                  </Draggable>
                                                  {optionWiseAns &&
                                                    optionWiseAns.length > 0 &&
                                                    optionWiseAns[index1] !=
                                                      undefined &&
                                                    optionWiseAns[index1][
                                                      val.ind
                                                    ] != undefined && (
                                                      <StatusIndicator
                                                        correct={
                                                          optionWiseAns[index1][
                                                            val.ind
                                                          ]
                                                        }
                                                      ></StatusIndicator>
                                                    )}
                                                </>
                                              )}
                                            {provided.placeholder}
                                          </div>
                                        )}
                                      </Droppable>
                                    )}
                                  </>
                                );
                              }
                            )}
                        </ListItemText>
                      </ListItem>
                    </List>
                  </Box>
                );
              })}
            </div>
          </DragDropContext>
        </>
      )}
    </div>
  );
}

const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "53vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default FIBDND;
